import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../../../filters';
import { DxDataGrid, DxColumn, DxFilterRow, DxSelection } from 'devextreme-vue/data-grid';

export default {
  name: 'recurringInvoices',
  components: {
    DxDataGrid,
    DxColumn,
    DxFilterRow,
    DxSelection,
  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      appData: [],
      lang: '',

      active: 'first',
      first: false,
      second: false,

      dateFrom: null,
      dateTo: null,
      invoices: [],
      invoicesCols: [],
      keyColumn: 'id',
      options: { pageSize: 10, total: 0, page: 1 },
      totalRow: 0,
      selectedInvoiceId: 0,
      invoice: null,
      customers: [],
      customersCols: [],
      customersTotalCount: 0,
      customersKeyColumn: 'customerKey',
      selectedRowKeys: [],
      selectionChangedBySelectBox: false,

      customerDataGrid: {},
      taskCount: 0,
    }
  },
  created() {
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.$root.$on('recurring_invoices_updated', this.init);
    this.fillInvoicesCols();
    this.fillCustomersCols();
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appId = this.dataObj.appId;
        this.appData = this.dataObj;

        this.customersTotalCount = this.appData.customersCount;
        this.customers = this.appData.customers;
      });
    },
    selectCustomers() {

      var lstCustomer = [];

      this.customerDataGrid.getSelectedRowsData().then(rowData => {

        for (var i = 0; i < rowData.length; i++) {

          var c = {
            billingGroup: rowData[i].billingGroup,
            customerKey: rowData[i].customerKey,
            customerName: rowData[i].customerName,
            isSelected: true
          };

          lstCustomer.push(c);
        }
      });

      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
        items: parameter,
      };
      console.log(lstCustomer);

      this.$store.state.notifier.asyncBlock(
        axios.post('/RecurringInvoicesActivity/SelectCustomers', parameter),
        response => {
          if (response.status == 200) {
            this.$alertMsg(this.$t('messages.SelectCustomersSuccess'), 2);
            this.active = 'second';
          }
        },
        err => err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$alertMsg(err.data.data.text)
      );

      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/RecurringInvoicesActivity/SelectCustomers', parameter)
        .then(response => {
          if (response.status == 200) {
            this.$alertMsg(this.$t('messages.SelectCustomersSuccess'), 2);
            this.active = 'second';
          }
          else {
            this.$alertMsg(response.data.data.text, 4);
          }
          loader.hide();
        })
        .catch(error => {
          loader.hide();
         this.$alertMsg(error.response.data);
        });
    },
    getInvoices() {
      var parameter = {
        from: this.dateFrom,
        to: this.dateTo
      };

      this.$store.state.notifier.asyncBlock(
        axios.post('/RecurringInvoicesActivity/GetInvoices', parameter),
        response => {
          if (response.status == 200) {
            this.totalRow = response.data.itemsCount;
            this.invoices = response.data.items;
            this.$root.$emit('datagrid_updated');
          }
        },
        err => err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$alertMsg(err.data.data.text)
      );

      //let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      //axios.post('/RecurringInvoicesActivity/GetInvoices', parameter)
      //  .then(response => {
      //    if (response.status == 200) {
      //      this.totalRow = response.data.itemsCount;
      //      this.invoices = response.data.items;
      //      this.$root.$emit('datagrid_updated');
      //    }
      //    else {
      //      this.$alertMsg(response.data.data.text, 1);
      //    }
      //    loader.hide();
      //  })
      //  .catch(error => {
      //    loader.hide();
      //   this.$alertMsg(error.response.data);
      //  });
    },
    selectInvoice() {
      if (this.selectedInvoiceId === 0)
        return;

      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
        creditInvoiceApplicationId: this.selectedInvoiceId
      };

      this.$store.state.notifier.asyncBlock(
        axios.post('/RecurringInvoicesActivity/SelectInvoice', parameter),
        response => {
          if (response.status == 200) {
            this.$root.$emit('invoice_selected');
          }
        },
        err => err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$alertMsg(err.data.data.text)
      );

      //let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      //axios.post('/RecurringInvoicesActivity/SelectInvoice', parameter)
      //  .then(response => {
      //    if (response.status == 200) {
      //      this.$root.$emit('invoice_selected');
      //    }
      //    else {
      //      this.$alertMsg(response.data.data.text, 1);
      //    }
      //    loader.hide();
      //  })
      //  .catch(error => {
      //    loader.hide();
      //   this.$alertMsg(error.response.data);
      //  });
    },
    pageChange(pInfo) {
      this.options.page = pInfo.pageNumber;
      this.options.pageSize = pInfo.pageSize;
      this.getInvoices();
    },
    fillInvoicesCols() {
      this.invoicesCols.push({ dataField: 'id', caption: this.$t('activities.id') });
      this.invoicesCols.push({ dataField: 'date', caption: this.$t('activities.date'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      this.invoicesCols.push({ dataField: 'mainCustkey', caption: this.$t('activities.customerKey') });
      this.invoicesCols.push({ dataField: 'mainCustomerName', caption: this.$t('activities.customerName') });
      this.invoicesCols.push({ dataField: 'amountName', caption: this.$t('activities.type') });
      this.invoicesCols.push({ dataField: 'amount', caption: this.$t('activities.amount') });
    },
    onChooseInvoice(info) {
      var invData = info.data;
      if ((invData === null) || (invData === undefined))
        return;

      this.selectedInvoiceId = invData.id;
    },
    onSelectInvoice(info) {
      var invData = info.data;
      if ((invData === null) || (invData === undefined))
        return;

      this.selectedInvoiceId = invData.id;

      this.selectInvoice();
    },
    fillCustomersCols() {
      this.customersCols.push({ dataField: 'billingGroup', caption: this.$t('activities.billingGroup') });
      this.customersCols.push({ dataField: 'customerKey', caption: this.$t('activities.customerKey') });
      this.customersCols.push({ dataField: 'customerName', caption: this.$t('activities.customerName') });
    },
    onInitialized(e) {
      this.customerDataGrid = e.component;
    },
  },
}
